var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 4.58268L15.7333 12.9368C15.6017 15.071 15.5358 16.1385 15 16.906C14.7355 17.2853 14.3949 17.6054 14 17.846C13.2025 18.3327 12.1333 18.3327 9.995 18.3327C7.85333 18.3327 6.7825 18.3327 5.98333 17.8452C5.58824 17.6041 5.24768 17.2834 4.98333 16.9035C4.44833 16.1352 4.38333 15.066 4.255 12.9285L3.75 4.58268M2.5 4.58268H17.5M13.38 4.58268L12.8108 3.40935C12.4333 2.62935 12.2442 2.24018 11.9183 1.99685C11.846 1.94295 11.7693 1.89501 11.6892 1.85352C11.3283 1.66602 10.895 1.66602 10.0292 1.66602C9.14083 1.66602 8.69667 1.66602 8.32917 1.86102C8.24793 1.90452 8.17044 1.9547 8.0975 2.01102C7.76833 2.26352 7.58417 2.66768 7.21583 3.47518L6.71083 4.58268",
    stroke: "#909090",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8bd3fe3a5674eed5f97dd0a420d90800.svg";
export { ForwardRef as ReactComponent };